const tags = {
    datepicker: () => import(/* webpackChunkName: 'datepicker' */ "sis_ui/modules/datepicker/index.jsx"),
    text: "text",
    "attr-text": "attr-text",
    "tag-input": () => import(/* webpackChunkName: 'tag-input' */ "sis_ui/modules/tag-input/index.jsx"),
    "data-view": () => import(/* webpackChunkName: 'data-view' */ "sis_ui/modules/data-view/index.jsx"),
    "toggle": () => import(/* webpackChunkName: 'toggle' */ "sis_ui/modules/toggle/index.jsx"),
    "smart-button": () => import(/* webpackChunkName: 'smart-button' */ "sis_ui/modules/buttons/button/button.jsx"),
    "button-group": () => import(/* webpackChunkName: 'button-group' */ "sis_ui/modules/buttons/buttonGroup/buttonGroup.jsx"),
    "smart-input": () => import(/* webpackChunkName: 'smart-input' */ "sis_ui/modules/input/index.jsx"),
    "smart-textarea": () => import(/* webpackChunkName: 'smart-textarea' */ "sis_ui/modules/textarea/index.jsx"),
    "multiselect": () => import(/* webpackChunkName: 'multiselect' */ "sis_ui/modules/multiSelect/index.jsx"),
    "addMultiselectItem": () => import(/* webpackChunkName: 'addMultiselectItem' */ "sis_ui/modules/multiSelect/addNewItem.jsx"),
    "view": () => import(/* webpackChunkName: 'view' */ "sis_ui/modules/view/index.jsx"),
    "smart-form": () => import(/* webpackChunkName: 'form' */ "sis_ui/modules/form/Form.jsx"),
    "smart-form-consumer": () => import(/* webpackChunkName: 'form-consumer' */ "sis_ui/modules/form/FormConsumer.jsx"),
    "smart-form-error-message": () => import(/* webpackChunkName: 'form-error-message' */ "sis_ui/modules/form/FormErrorMessage.jsx"),
    "treeselect": () => import(/* webpackChunkName: 'treeselect' */ "sis_ui/modules/treeSelect/index.jsx"),
    "oldFilter": () => import(/* webpackChunkName: 'oldFilter' */ "sis_ui/modules/oldFilter/oldIndex.jsx"),
    "filter": () => import(/* webpackChunkName: 'filter' */ "sis_ui/modules/filter/index.jsx"),
    "entity-render": () => import(/* webpackChunkName: 'entity-render' */ "sis_ui/modules/entity-render/index.jsx"),
    "entity-render-field": () => import(/* webpackChunkName: 'entity-render-field' */ "sis_ui/modules/entity-render/field.jsx"),
    "entity-render-field-label": () => import(/* webpackChunkName: 'entity-render-field-label' */ "sis_ui/modules/entity-render/label.jsx"),
    "highlight-wrapper": () => import(/* webpackChunkName: 'highlight' */ "sis_ui/modules/highlight/HighlightWrapper.jsx"),
    "highlight": () => import(/* webpackChunkName: 'highlight' */ "sis_ui/modules/highlight/Highlight.jsx"),
    "checkbox": () => import(/* webpackChunkName: 'checkbox' */ "sis_ui/modules/checkbox/index.jsx"),
    "datepicker" : () => import(/* webpackChunkName: 'datepicker' */"sis_ui/modules/datepicker/datepicker.jsx" ),
    "colorpicker" : () => import(/* webpackChunkName: 'colorpicker' */"sis_ui/modules/colorpicker/colorpicker.jsx" ),
    "modal" : () => import(/* webpackChunkName: 'modal' */"sis_ui/modules/modal/index.jsx" ),
    "download-file" : () => import(/* webpackChunkName: 'download-file' */"sis_ui/modules/download-file/index.jsx"),
    "page" : () => import(/* webpackChunkName: 'page' */"sis_ui/modules/navigation/pageLoader.jsx"),
    "dropzone" : () => import(/* webpackChunkName: 'dropzone' */"sis_ui/modules/dropzone/index.jsx"),
    "popover" : () => import(/* webpackChunkName: 'popover' */"sis_ui/modules/popover/index.js"),
    "panel" : () => import(/* webpackChunkName: 'panel' */"sis_ui/modules/panel/index.jsx"),
    "timepicker" : () => import(/* webpackChunkName: 'timepicker' */"sis_ui/modules/timepicker/index.jsx"),
    "recurrence-pattern" : () => import(/* webpackChunkName: 'recurrence-pattern' */"sis_ui/modules/recurrence-pattern/index.jsx"),
    "accordion" : () => import(/* webpackChunkName: 'accordion' */"sis_ui/modules/accordion/accordion.jsx"),
    "accordion-group" : () => import(/* webpackChunkName: 'accordion-group' */"sis_ui/modules/accordion/accordionGroup.jsx"),
    "accordion-header" : () => import(/* webpackChunkName: 'accordion-header' */"sis_ui/modules/accordion/header.jsx"),
    "accordion-body" : () => import(/* webpackChunkName: 'accordion-body' */"sis_ui/modules/accordion/body.jsx"),
    "msgbox-container" : () => import(/* webpackChunkName: 'accordion-body' */"sis_ui/modules/notifications/MsgBoxContainer.jsx"),
    "material-modal" : () => import(/* webpackChunkName: 'material-modal' */"sis_ui/modules/material-modal/index.jsx"),
    "contextual-notes" : () => import(/* webpackChunkName: 'contextual-notes' */"sis_ui/modules/contextual-notes/ContextualNotes.jsx"),
    "teacher-select" : () => import(/* webpackChunkName: 'teacher-select' */"sis_ui/modules/teacher-select/TeacherSelect.jsx"),
};

let componentsSettings = {
    'datepicker': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
        'hasAfterRenderCallback': true,
    },
    'colorpicker': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true/*,
        'hasAfterRenderCallback': true,*/
    },
    'text': {
        'display': 'inline',
        'wrapperTag': 'div',
        'idRequired': false,
    },
    'attr-text': {
        'display': 'none',
        'wrapperTag': 'div',
        'idRequired': false,
    },
    'tag-input': {
        'display': 'inline',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'data-view': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
        'styles': 'height:100%;width:100%;min-height:inherit;position:relative;',
        'hasAfterRenderCallback': true,
    },
    'smart-button': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
        'styles': 'position:relative;',
        'hasAfterRenderCallback': true,
    },
    'toggle': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'button-group': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'button-group-item': {
        'idRequired': true,
    },
    'smart-textarea': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'smart-input': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'multiselect': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'addMultiselectItem': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'treeselect': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'smart-form': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'smart-form-consumer': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'smart-form-error-message': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'filter': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'oldFilter': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'entity-render': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'entity-render-field': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': false,
    },
    'highlight-wrapper': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': false,
    },
    'checkbox': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'modal': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'page': {
        'display': 'block',
        'wrapperTag': 'div',
        'idRequired': false,
    },
    'dropzone': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'popover': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'panel': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'timepicker': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'recurrence-pattern': {
        'display': 'inline-block',
        'wrapperTag': 'div',
        'idRequired': true,
        'styles': 'width:100%;',
    },
    'accordion' : {
        'display': '',
        'wrappedTag': 'div',
        'isRequired': true,
    },    
    'accordion-group' : {
        'display': '',
        'wrappedTag': 'div',
        'isRequired': true,
    },
    'accordion-header' : {

        'display': '',

        'wrappedTag': 'div',

        'isRequired': true,

    },
    'accordion-body' : {

        'display': '',

        'wrappedTag': 'div',

        'isRequired': true,

    },
    'msgbox-container': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': false,
    },
    'contextual-notes': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': true,
    },
    'teacher-select': {
        'display': '',
        'wrapperTag': 'div',
        'idRequired': false,
    },
}

export let uiComponents = {
    tags: tags,
    getSetting: (tag, setting) => (componentsSettings.hasOwnProperty(tag) && componentsSettings[tag].hasOwnProperty(setting) ? componentsSettings[tag][setting] : null),
}